import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Zap } from 'lucide-react';
import CaptureModal from './CaptureModal';

const CaptureFAB = () => {
  const { api } = useAuth();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [fabVisible, setFabVisible] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/api/capture/settings');
        setFabVisible(res.data.fab_visible !== false);
      } catch { /* default visible */ }
    };
    fetchSettings();
  }, [api]);

  // Hide on ritual/full-screen pages and pages with their own FAB
  const hiddenPaths = ['/boussole', '/debrief', '/driving', '/onboarding', '/chat', '/captures', '/engagements'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;
  if (!fabVisible) return null;

  return (
    <>
      <button
        data-testid="capture-fab"
        onClick={() => setShowModal(true)}
        aria-label="Capturer une idée"
        className="fixed z-40 bottom-24 lg:bottom-8 right-6 w-14 h-14 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/25 transition-all duration-200 hover:scale-110 active:scale-95"
        style={{ backgroundColor: '#FFD60A' }}
      >
        <Zap className="w-6 h-6 text-gray-900" />
      </button>

      {showModal && <CaptureModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default CaptureFAB;
